import { Directive, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { TopMenuEvent } from './top-menu-events.model';
import { SearchSuggestion, SearchSuggestionGroup } from './search-suggestions.model';

/** Inputs and outputs of the top menu. IcHeaderComponent binds every one of them. */
@Directive()
export abstract class TopMenuBindings {
  @Input() settingsData: any = {};
  @Input() logoUrl = '';
  @Input() logoDisabled = false;
  @Input() isPreview = false;
  @Input() disableAccess = false;
  @Input() isNative = false;
  @Input() marketplaceText = '';
  @Input() showCommunity = false;
  @Input() show247 = false;
  @Input() showAffiliate = false;
  @Input() affiliateLabel = '';
  @Input() showCurrency = false;
  @Input() currency = '';
  @Input() currencyList: any[] = [];
  @Input() showCart = false;
  @Input() cartCount = 0;
  @Input() showSignIn = false;
  @Input() showAvatar = false;
  @Input() profilePic = '';
  @Input() initials = '';
  @Input() searchText = '';
  @Input() events: TopMenuEvent[] = [];
  @Input() recentSearches: string[] = [];
  @Input() suggestions: SearchSuggestionGroup[] = [];
  @Input() suggestionsLoading = false;
  @Input() suggestionsFailed = false;
  @HostBinding('class.tm-scrolled') @Input() scrolled = false;

  @Output() searchTextChange = new EventEmitter<string>();
  @Output() search = new EventEmitter<void>();
  @Output() logoClick = new EventEmitter<void>();
  @Output() marketplaceSelect = new EventEmitter<'market' | 'event'>();
  @Output() community = new EventEmitter<void>();
  @Output() channel247 = new EventEmitter<void>();
  @Output() affiliate = new EventEmitter<void>();
  @Output() currencyChange = new EventEmitter<string>();
  @Output() cartClick = new EventEmitter<void>();
  @Output() signIn = new EventEmitter<void>();
  @Output() profileToggle = new EventEmitter<void>();
  @Output() eventsNeeded = new EventEmitter<void>();
  @Output() openEvent = new EventEmitter<TopMenuEvent>();
  @Output() pickSuggestion = new EventEmitter<SearchSuggestion>();
}
